import React from "react";
import { Card, Input, Radio, Spin, Empty, Typography, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export function StepSelectTherapy({
  loading,
  therapies,
  search,
  onSearch,
  selectedTherapyId,
  onSelect,
}) {
  const { t } = useTranslation(["therapy", "common"]);

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <Input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          allowClear
          prefix={<SearchOutlined />}
          placeholder={t("wizard.terapia.buscarPlaceholder")}
        />
      </div>

      {loading ? (
        <div
          style={{
            height: 320,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin size="large" />
        </div>
      ) : !therapies?.length ? (
        <Empty description={t("wizard.terapia.vacio")} />
      ) : (
        <Radio.Group
          value={selectedTherapyId}
          onChange={(e) => onSelect(e.target.value)}
          style={{ width: "100%" }}
        >
          <div className="revi-wizard-therapy-grid">
            {/*
              La variable del map se llamaba "t" y tapaba a la funcion de
              traduccion. Se renombra a "terapia" para que dentro del map se
              pueda seguir usando t(...).
            */}
            {therapies.map((terapia) => {
              const selected = selectedTherapyId === terapia._id;

              return (
                <Card
                  key={terapia._id}
                  variant="outlined"
                  className={`revi-therapy-select-card ${selected ? "is-selected" : ""}`}
                  onClick={() => onSelect(terapia._id)}
                >
                  <div className="revi-therapy-select-card__top">
                    <Radio value={terapia._id} />
                    <div className="revi-therapy-select-card__main">
                      <div className="revi-therapy-select-card__title">
                        {terapia.title}
                      </div>

                      <div className="revi-therapy-select-card__meta">
                        {/* Contador: "1 salas" ya se veia mal en castellano. */}
                        {Array.isArray(terapia?.scenes) ? (
                          <Tag>
                            {t("common:contadores.salas", {
                              count: terapia.scenes.length,
                            })}
                          </Tag>
                        ) : null}
                        {terapia.visibility ? (
                          <Tag>{terapia.visibility}</Tag>
                        ) : null}
                      </div>

                      {terapia.description ? (
                        <Text
                          type="secondary"
                          className="revi-therapy-select-card__desc"
                        >
                          {terapia.description}
                        </Text>
                      ) : null}
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        </Radio.Group>
      )}
    </div>
  );
}
